import remove from 'lodash/remove';
import api from '@/api';

export default {
  namespaced: true,

  state: {
    alertRules: [],
  },

  getters: {
  },

  actions: {
    async GetAlertRules({ commit }, params) {
      const { alertRules } = await api.alertRule.getAlertRules({ ...params });
      commit('SET_ALERT_RULES', alertRules);
      return alertRules;
    },
    async AddAlertRule({ commit }, form) {
      const { alertRule } = await api.alertRule.createAlertRule({ ...form });
      commit('ADD_ALERT_RULE', alertRule);
      return alertRule;
    },
    async UpdateAlertRule({ commit }, form) {
      const { alertRule } = await api.alertRule.updateAlertRule({ ...form });
      commit('UPDATE_ALERT_RULE', alertRule);
      return alertRule;
    },
    async DeleteAlertRule({ commit }, alertRule) {
      await api.alertRule.deleteAlertRule({
        projectId: alertRule.projectId,
        alertRuleId: alertRule.id,
      });
      commit('DELETE_ALERT_RULE', alertRule);
    },
  },
  mutations: {
    SET_ALERT_RULES(state, alertRules) {
      state.alertRules = alertRules;
    },
    ADD_ALERT_RULE(state, alertRule) {
      const { alertRules } = state;
      state.alertRules = [...alertRules, alertRule];
    },
    UPDATE_ALERT_RULE(state, alertRule) {
      const { alertRules } = state;
      const target = alertRules.find(item => item.id === alertRule.id);

      if (target) {
        Object.assign(target, alertRule);
        state.alertRules = [...alertRules];
      }
    },
    DELETE_ALERT_RULE(state, alertRule) {
      const { alertRules } = state;
      remove(alertRules, item => item.id === alertRule.id);
      state.alertRules = [...alertRules];
    },
  },
};
